<app-navbar></app-navbar>
<!--Page Header-->
<!-- <div id="page-head" class="mb-10"> -->
<div class="flex-grow">
  <div class="mb-10 banner-container">
    <div class="grid grid-cols-12">
      <div class="col-span-12">
        <div class="w-full h-[450px] banner-wrapper">
          <img src="/assets/images/banners/terms.jpg" alt="" class="object-cover w-full h-full">
          <div class="flex items-center h-full banner-container-inner">
            <div class="container mx-auto">
              <div class="p-[30px] text-center mt-[7em]">
                <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                  <span class="font-bold mr-2">Privacy Policy</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Page Content-->
<section class="w-full min-h-screen mt-10">
  <div class="container mx-auto">
    <div class="flex flex-wrap">
      <div class="w-full mt-10 mb-10">

        <div class="container mx-auto px-6 py-12">
          <div class="bg-white p-3 lg:p-8 rounded-lg  mt-[-88px]">
            <h1 class="text-3xl font-bold text-gray-800 mb-0">Privacy Policy</h1>
            <p class="mb-6 mt-2">
              At <span class="font-semibold">MedEase</span>, we prioritize your privacy and are committed to protecting
              the personal information you share with us. This Privacy Policy outlines how we collect, use, and
              safeguard your data when you access our platform.
            </p>

            <h2 class="text-2xl font-medium text-gray-800 mb-0"> Information We Collect</h2>
            <p class="mb-4 mt-2">
              We collect information necessary to provide you with healthcare services, including but not limited to:
            </p>
            <ul class="list-disc list-inside mb-6">
              <li class="leading-[1.8]"><strong>Personal Information:</strong> Full name, contact details, date of
                birth, and identification information.</li>
              <li class="leading-[1.8]"><strong>Health Information:</strong> Medical history, current health status, and
                other health-related data you voluntarily provide.</li>
              <li class="leading-[1.8]"><strong>Payment Information:</strong> Credit card or payment details for billing
                purposes.</li>
            </ul>

            <h2 class="text-2xl font-medium text-gray-800 mb-0"> How We Use Your Information</h2>
            <p class="mb-4 mt-2">We use your information to:</p>
            <ul class="list-disc list-inside mb-6">
              <li class="leading-[1.8]" class="leading-[1.8]">Connect you with healthcare providers and manage your
                appointments.</li>
              <li class="leading-[1.8]" class="leading-[1.8]">Facilitate online consultations with healthcare
                professionals.</li>
              <li class="leading-[1.8]" class="leading-[1.8]">Provide customer support and respond to inquiries.</li>
              <li class="leading-[1.8]" class="leading-[1.8]">Send appointment reminders, follow-ups, or health-related
                notifications.</li>
              <li class="leading-[1.8]" class="leading-[1.8]">Improve the user experience of our platform and develop
                new features.</li>
              <li class="leading-[1.8]" class="leading-[1.8]">Process payments securely.</li>
            </ul>

            <h2 class="text-2xl font-medium text-gray-800 mb-0">Sharing of Information</h2>
            <p class="mb-4 mt-2">We do not sell or share your personal information with third parties for marketing
              purposes. Your data may be shared with:</p>
            <ul class="list-disc list-inside mb-6">
              <li class="leading-[1.8]"><strong>Healthcare Providers:</strong> For the purpose of your consultation and
                treatment.</li>
              <li class="leading-[1.8]"><strong>Payment Processors:</strong> To facilitate billing.</li>
              <li class="leading-[1.8]"><strong>Service Providers:</strong> For operational tasks such as hosting, data
                storage, or analytics, under strict confidentiality agreements.</li>
            </ul>

            <h2 class="text-2xl font-medium text-gray-800 mb-0"> Data Security</h2>
            <p class="mb-6 mt-2">
              We implement strict security measures to protect your personal data, including encryption, secure servers,
              and regular security audits. In the event of a breach, we will notify affected users as required by law.
            </p>

            <h2 class="text-2xl font-medium text-gray-800 mb-0"> Data Retention</h2>
            <p class="mb-6 mt-0">
              We retain your personal information only as long as necessary to fulfill the purposes outlined in this
              policy or as required by law.
            </p>

            <h2 class="text-2xl font-medium text-gray-800 mb-0"> User Control</h2>
            <p class="mb-6 mt-2">
              You have the right to access, correct, or delete your personal data. If you wish to exercise these rights,
              please contact us at <span class="font-semibold">+91 9446062493</span>.
            </p>

            <h2 class="text-2xl font-medium text-gray-800 mb-0"> Cookies and Tracking Technologies</h2>
            <p class="mb-6 mt-2">
              Our platform uses cookies and similar technologies to enhance your browsing experience. You may opt to
              disable cookies, but doing so may affect the platform’s functionality.
            </p>

            <h2 class="text-2xl font-medium text-gray-800 mb-0">Changes to This Policy</h2>
            <p class="mb-6 mt-2">
              We may update this Privacy Policy from time to time. Any changes will be communicated through the
              platform, and continued use of the services constitutes your acceptance of the updated terms.
            </p>

            <h2 class="text-2xl font-medium text-gray-800 mb-0"> Contact Us</h2>
            <p class="mb-2 mt-2">
              If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at <a
                href="mailto:[sales@onetikk.com]"
                class="text-[#45a6d1] hover:text-[#000] ease-in duration-300 underline">sales&#64;onetikk.com</a>
            </p>
          </div>
        </div>


      </div>
    </div>

  </div>
</section>
<app-message></app-message>
<app-footer></app-footer>